<!-- START: Confirm dialog for deleting the campaign -->
<p-confirm-dialog />
<!-- END: Confirm dialog for deleting the campaign -->

<div class="container card mt-3">
  <div class="pt-4 d-flex-inline p-2">
    <h4>Campaign list</h4>
  </div>
  <div class="campaign-list">
    <input
      type="text"
      placeholder="Search campaigns..."
      [formControl]="searchControl"
      class="form-control mt-3 mb-3"
    />

    <!-- Campaign list -->
    <ul class="list-group">
      <li *ngFor="let campaign of campaigns" class="list-group-item">
        <div class="d-inline-flex justify-content-between w-full">
          <a
            [routerLink]="['/campaign/edit']"
            [state]="{
              campaignData: {
                campaignName: campaign.campaignName,
                campaignId: campaign.campaignId,
              },
            }"
            [class.greyed-out]="campaign.isInProgress"
          >
            {{ campaign.campaignName }}
            <span class="badge bg-secondary ms-2">
              {{ campaign.phases?.length || 0 }}
              {{ (campaign.phases?.length || 0) === 1 ? "phase" : "phases" }}
            </span>
          </a>
          <!--          <span class="btn btn-sm" (click)="deleteCampaign(campaign.campaignName)">-->
          <!--                                <i class="pi pi-trash text-red-500"></i>-->
          <!--                    </span>-->

          <span
            [pTooltip]="
              campaign.isInProgress
                ? 'This campaign is in process of deletion!'
                : ''
            "
            tooltipPosition="right"
          >
            <button
              [disabled]="campaign.isInProgress"
              type="button"
              class="btn btn-sm"
              (click)="deleteCampaignDialog($event, campaign.campaignName)"
            >
              <i class="pi pi-trash text-red-500"></i>
            </button>
          </span>
        </div>
      </li>
      <li *ngIf="campaigns.length === 0" class="list-group-item text-muted">
        No campaigns found.
      </li>
    </ul>

    <!-- Pagination -->
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [rowsPerPageOptions]="[10, 20, 30]"
      class="mt-3"
    >
    </p-paginator>
  </div>
  <p-dialog
    [(visible)]="loading"
    [modal]="true"
    [closable]="false"
    [dismissableMask]="false"
    [baseZIndex]="4"
    showHeader="false"
    styleClass="spinner-dialog"
  >
    <div class="spinner-content">
      <p-progress-spinner></p-progress-spinner>
      <div class="spinner-label"></div>
    </div>
  </p-dialog>
</div>
